import * as types from "../actionTypes";

export const setSalesAndMarketingExpenseByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SALES_AND_MARKETING_EXPENSE_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setSalesAndMarketingExpenseByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_SALES_AND_MARKETING_EXPENSE_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceSalesAndMarketingExpenseYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_SALES_AND_MARKETING_EXPENSE_YEARS,
      key,
      payload,
    });
  };
};

export const resetSalesAndMarketingExpenseReducer = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_SALES_AND_MARKETING_EXPENSE_REDUCER,
      key,
      payload,
    });
  };
};
